import React, { FC, useRef, useState } from 'react';
import { DotLottleLoader } from '../../components/Loader';
import { IconAdd, IconConfirm, IconClose } from '../../utils/icons';
import { ActionIconButton, InlineInput, SubLine } from './constants';

interface IProps {
  label: string;
  parentColor?: string;
  placeholder?: string;
  onSave(newItem: any): Promise<string | undefined>;
}

export const AddListItem: FC<IProps> = ({
  label,
  parentColor = '#D5D0C8',
  placeholder = 'Sub-profession name…',
  onSave,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [editing, setEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [newName, setNewName] = useState('');

  const handleSave = async () => {
    if (!newName.trim()) return;
    setLoading(true);
    const responseMessage = await onSave({ name: newName.trim() });
    setLoading(false);
    if (!responseMessage) {
      setEditing(false);
      setNewName('');
    }
  };

  const handleCancel = () => {
    setEditing(false);
    setNewName('');
  };

  if (editing) {
    return (
      <div className="flex items-center gap-2 pl-7 pr-4 py-1.5 sm:pl-4 sm:pr-3">
        <SubLine color={parentColor} />
        <InlineInput
          ref={inputRef}
          autoFocus
          placeholder={placeholder}
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') handleSave();
            if (e.key === 'Escape') handleCancel();
          }}
        />
        <div className="flex items-center gap-0.5 shrink-0">
          {!loading && (
            <>
              <ActionIconButton tone="confirm" title="Save" onClick={handleSave}>
                <IconConfirm size={13} />
              </ActionIconButton>
              <ActionIconButton title="Cancel" onClick={handleCancel}>
                <IconClose size={13} />
              </ActionIconButton>
            </>
          )}
          {loading && <DotLottleLoader sx={{ width: 28, height: 28 }} fill={false} />}
        </div>
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={() => setEditing(true)}
      className="flex items-center gap-1.5 pl-7 pr-4 py-2 sm:pl-4 w-full text-left bg-transparent border-0 text-accent-text hover:text-accent-text text-[12.5px] font-medium cursor-pointer transition-colors"
    >
      <IconAdd size={13} />
      {label}
    </button>
  );
};
